import { StyledTooltipContent } from "./Storybook.styles";

const TooltipContent = ({ title, description }) => (
    <StyledTooltipContent>
      {title && <div className="tour-title">{title}</div>}
      {description && <p className="tour-description">{description}</p>}
    </StyledTooltipContent>
  );
  export default TooltipContent;